import * as React from "react";
import {
    Form,
    Field,
    FormElement,
    FormRenderProps,
    FieldWrapper,
    FormSubmitClickEvent,
} from "@progress/kendo-react-form";
import { Editor} from "@progress/kendo-react-editor";
import {
    Grid,
    GridColumn,
    GridCellProps,
} from "@progress/kendo-react-grid";
import { Button, ButtonGroup } from "@progress/kendo-react-buttons";
import { FormCheckbox, FormInput } from "../FormComponents";
import { emailRequiredValidator } from "../validators";

import { Label } from "@progress/kendo-react-labels";
import { TextBox, TextArea } from "@progress/kendo-react-inputs";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Loader } from "@progress/kendo-react-indicators";

import { PDFExport, savePDF } from "@progress/kendo-react-pdf";

import { useAppSelector } from "../../store/store";
import ExamEdit from "./ExamEdit";
import ExamViewClientPet from './ExamViewClientPet';
import ExamViewAttachments from './ExamViewAttachments';
import ExamPDF from './ExamPDF';

import { useSendMailMutation } from '../../store/sunbright-api';

const info = [
    {
        t: "<h2 style=\"text-align: center;\"><strong>Service Eligibility<\/strong><\/h2>",
        h: "60px",
        gap: "0px"
    },
    {
        t: "<h2 style=\"text-align: center;\"><strong>Participant (Client, Pet Owner or Guardian) Release Agreement<\/strong><\/h2>\r\n<p>Community Veterinary Outreach (&ldquo;CVO&rdquo;) is a volunteer-based registered charity that provides veterinary care and treatment to animals to improve the health of the animal and support the well-being of their owners or guardians. CVO accepts participants (client, pet owner, or guardian) on a referral basis from community partnerships that include area shelters, municipal public health, community health centres and mental health organizations. The care and treatment provided by CVO involves risk and CVO cannot assume responsibility for you or your pets&rsquo; exposure to these risks. Therefore, in order to participate with CVO and allow your pets to receive care and treatment, please review and sign this Agreement. If you have not yet reached the age of 18, a parent or legal guardian must sign this Agreement for you. If you have any questions please contact the primary referral agency for this clinic, A copy of this Agreement will be provided to you upon request.<\/p>\r\n<p style=\"text-align: center;\"><strong>ALL<\/strong> sections of this form <strong>MUST<\/strong> be completed to be accepted. <br \/><\/p>\r\n<p>I am 18 years of age or older and am bringing my pet voluntarily to CVO to be treated and to receive veterinary care. I agree to allow CVO to treat my pet on my own free will.<\/p>\r\n<p>I understand that my pet and I may be exposed to other animals and pet owners while being treated by CVO. Other animals may carry certain diseases which can spread to me and\/or my pet. Also, these other animals can bite, scratch, or otherwise injure my pet or me, and these other animals do not belong to CVO. By allowing CVO to treat my pet, I will not hold CVO, or any social agency working with CVO (including the primary referral agency indicated above), liable or responsible for any loss, damage, illness or injury, including death, suffered by my pet or me at a CVO clinic or treatment event.<\/p>\r\n<p>I have read and I understand this Agreement and the referring working (witnessed herein) acting on behalf of the CVO has explained this Agreement to me before signing freely and voluntarily.<\/p>\r\n<p><strong>Please date and sign in front of a witness who is at least 18 years old:<\/strong><\/p>\r\n\r\n<hr \/>",
        h: "480px",
        gap: "0px"
    },
    {
        t: "<h2 style=\"text-align: center;\"><strong>Community Veterinary Outreach Health Screening<\/strong><\/h2>\r\nAs part of our COVID-19 Health and Safety Plan, we are implementing health screening for all clients and volunteers who physically participate in any Outreach event.<br/><br/><strong>All clients and volunteers must complete this waiver and sign with their initials.</strong>",
        h: "160px",
        gap: "32px"
    },
    {
        t: "Fever, Chills, Cough, Difficulty breathing<br/>Sore throat, Difficulty swallowing<br/>Congested or runny nose<br/>Loss of taste or smell<br/>Pink eye, Headache,<br/>Digestive issues<br/>Muscle aches, Extreme tiredness, Dizziness/ balance issues",
        h: "140px",
        gap: "32px"
    },
    {
        t: "Note: if you or the member of your household who was told to isolate subsequently took a COVID-19 test and received a negative result, answer 'NO' to this question.",
        h: "60px",
        gap: "32px"
    },
    {
        t: "Close contact includes living in the same house, or being at a distance of less than 2 metres from a person for a period of more than 15 minutes.",
        h: "60px",
        gap: "32px"
    },
    {
        t: "We expect our volunteers and clients to exercise good judgement and to not attend an Outreach event if feeling unwell or concerned about putting others at risk. If you have reason to believe you may have been exposed to COVID-19, are waiting for the results of a COVID test on yourself, or have had close contact with someone who may have been exposed, you cannot be allowed to enter the event venue or come into contact with others related to this event. A reminder that current public health requirements mandate isolation for a period of 10 days (BC) or 14 days (MB, ON) following the onset of symptoms, even if symptoms resolve. If, in the past 10 or 14 days, you have experienced any symptoms of COVID-19, do not attend the Outreach event unless you have received a negative COVID-19 test. All volunteers and clients must adhere to all safety procedures at any Outreach event, including only one person entering with their pet, wearing of a mask over the mouth and nose at all times, and sanitizing hands before entering the venue.",
        h: "170px",
        gap: "32px"
    },
    {
        t: "<h2 style=\"text-align: center;\"><strong>Personal Information Policy<\/strong><\/h2>\r\n" +
            "I understand that Community Veterinary Outreach has a Personal Information policy in accordance with the requirements of the Personal Information Protection and Electronic Documents Act.<br/><br/>By signing below, I am consenting to the collection, use and disclosure of my personal information(such as name, phone number, address, and pet's medical records) in accordance with the purposes set out in the Policy which includes the following:<br/><br/>" +
            "1. Maintaining complete and accurate client files, and complying with the requirements of provincial acts and regulations;<br/>" +
            "2. Providing goods and services to veterinary clients, including contacting clients to schedule appointments and follow up on patient treatment<br/>" +
            "3. Communicating and working with third parties providing veterinary medical or other services to clients, including other veterinary facilities, laboratories, and insurance companies for which you have an existing policy<br/>" +
            "4. Sharing your pet's medical records, including rabies vaccination status, to support the public health department's efforts to track the risk of rabies transmission in your municipality; and<br/>" +
            "5. Use of non- identified information collected from the referral form for research purposes in order to fulfill Community Veterinary Outreach's mandate of 'contributing to the scientific knowledge base on social issues involving animals.'<br/><br/>" +
            "I understand that:<br/>" +
            "1. My personal information will not be used or disclosed for purposes other than those for which it was collected.Except with my consent, or except where use or disclosure is required by law;<br/>" +
            "2. I have the right to view my personal information and have it amended, if inaccurate or incomplete; and<br/>" +
            "3. A copy of the Policy will be provided on request.<br/><br/>" +
            "I consent to photographs being taken of myself and my pet, and waive ownership of any photographic records taken by Community Veterinary Outreach and agree to permit Community Veterinary Outreach to use my image, or my pet's image, (in photograph, digital, or electronic form) for and in Community Veterinary Outreach publications, posters, web-site or other medial, without limitation, and agree not to make any claim for misappropriation of personality, breach of privacy, or other loss or damages against Community Veterinary Outreach in respect thereof. Any photos taken will not be distributed for use by a third party.",
        h: "600px",
        gap: "32px"
    },
    {
        t: "<h2 style=\"text-align: center;\"><strong>Referral Questionnaire<\/strong><\/h2>" +
            "Community Veterinary Outreach's program provides preventative veterinary care only.\n\nPet owners should NOT wait for a clinic if they have a sick or injured pet.They should be strongly advised to seek veterinary care immediately.\n\n" +
            "Referred clients must meet all of the following criteria:\n\n" +
            "1. Client is homeless, transitionally-housed or vulnerably-housed (COH or CHRN definition of homeless)\n" +
            "2. Client is receiving government social support or has no income; or if the client has no ID - is making regular use of shelter or agency services\n" +
            "3. Client does NOT have an existing veterinarian - client - patient relationship (VPCR), defined as having their animal examined or treated by a veterinarian in the past 12 months.\n\n" +
            "All information collected is strictly confidential and during analysis of data all personal and/or identifying information will be stripped and destroyed. This questionnaire is voluntary and veterinary services will not be withheld if any or all of the questions, other than essential client and pet information needed by law, are not answered.\n" +
            "Answering questions regarding pet bites will not result in a legal complaint by Community Veterinary Outreach.\n\n",
        h: "360px",
        gap: "0px"
    },
    {
        t: "<span style=\"color:blue\">Client Information</span>",
        text: "Client Information",
        h: "40px",
        gap: "32px"
    },
    {
        t: "<span style=\"color:blue\">Pet Ownership Information</span>",
        text: "Pet Ownership Information",
        h: "40px",
        gap: "32px"
    },
    {
        t: "We are dedicated to improving the health of both people and pets, and may have human healthcare and social support services available at veterinary outreach clinics. To help us understand how we can best support you, please answer the following questions.",
        h: "60px",
        c: "",
        gap: "32px"
    },
    {
        t: "<span style=\"color:blue\">Pet History</span>",
        text: "Pet History:",
        h: "40px",
        gap: "0px"
    },
    {
        t: "<span style=\"color:blue\">Any change in the following:</span>",
        text: "Any change in the following:",
        h: "40px",
        gap: "32px"
    },
    {
        t: "<span style=\"color:blue\">Have you noted any of the following:</span>",
        text: "Have you noted any of the following:",
        h: "40px",
        gap: "32px"
    },
    {
        t: "<span style=\"color:blue\">Physical Exam Findings:</span>",
        text: "Physical Exam Findings:",
        h: "40px",
        gap: "32px"
    },
    {
        t: "<span style=\"color:blue\">Assessment, Diagnostics, Treatment:</span>",
        text: "Assessment, Diagnostics, Treatment:",
        h: "40px",
        gap: "32px"
    },
    {
        t: "<span style=\"color:blue\">Services Performed:</span>",
        text: "Services Performed:",
        h: "40px",
        gap: "32px"
    },
    {
        t: "<span style=\"color:blue\">Personnel:</span>",
        text: "Personnel:",
        h: "40px",
        gap: "32px"
    },
    {
        t: "<span style=\"color:blue\">Client Communication:</span>",
        text: "Client Communication:",
        h: "40px",
        gap: "32px"
    },
    {
        t: "<span style=\"color:blue\">-</span>",
        text: "-",
        h: "40px",
        gap: "32px"
    },
    {
        t: "If there are any questions while completing this form, please e-mail info@vetoutreach.org for further direction.",
        h: "32px",
        gap: "0px"
    },
    {
        t: "If there are any questions while completing this form, please e-mail saskatoon@vetoutreach.org for further direction.",
        h: "32px",
        gap: "0px"
    },
    {
        t: "<span style=\"color:blue\">Follow Up Services Requested:</span>",
        text: "Follow Up Services Requested:",
        h: "40px",
        gap: "32px"
    },
]

export interface ExamTabProps {
    examID: string;
    examData: any;
    category: string,
    viewOnly:boolean,
    qWidth: string,
}

const toReactComponent = (html:any) => <span dangerouslySetInnerHTML={{ __html: html }} />

const cellWithHtml = (props: GridCellProps) => {
    const drugFields: number[] = [248, 249];

    const fieldVal = props.field ? props.dataItem[props.field] : null;

    const color = (fieldVal && props.dataItem.alert) ? ((fieldVal.indexOf(props.dataItem.alert) !== -1) ? "red" : "green") : "";
    const style = { color: color };

    let displayVal = fieldVal;
    if (fieldVal && (fieldVal != null) && (drugFields.indexOf(props.dataItem.findingID) !== -1)) {
        const fieldWithBold = fieldVal.replace(/(Drug Name:)(.*)(\n|\r])/g, "$1<font color=\"green\">$2</font>$3");
        displayVal = toReactComponent(fieldWithBold.replaceAll("\r", "<br/>").replaceAll("\n", "<br/>"));
    }
    else if (fieldVal !== null) {
        displayVal = toReactComponent(fieldVal);
    }

    return (
        <td role="gridcell" style={style}>
            {displayVal}
        </td>
    );
};

const ExamTab = ({
    examID,
    examData,
    category,
    viewOnly,
    qWidth,
    ...windowProps
}: ExamTabProps) => {

    const [sendMail, covetResponse] = useSendMailMutation();

    const EmailForm = React.useRef<any>(null);

    const auth = useAppSelector((state) => state.auth);
    const [canEdit, setCanEdit] = React.useState<boolean>(examData && (examData.status !== "Closed") &&
        auth && (auth.user !== undefined) && auth.user.role && (category !== "Attachments") &&
        (((auth.user.role.indexOf("Admin") !== -1) || (auth.user.role.indexOf("Veterinarian") !== -1) ||
            ((auth.user.role.indexOf("Intake") !== -1) && (category !== "Comments")))));
    //const [canEmail, setCanEmail] = React.useState<boolean>(auth.user.region !== 1);
    const [canEmail, setCanEmail] = React.useState<boolean>((category === "Vaccinations") || (category === "CoVet"));

    const [canPrint, setCanPrint] = React.useState<boolean>(category === "Vaccinations");
    const [canPDF, setCanPDF] = React.useState<boolean>((category === "Vaccinations") || (category === "ExamRecord"));
    const [isEdit, setIsEdit] = React.useState<boolean>(false);
    const [showEmail, setShowEmail] = React.useState<boolean>(false);
    const [showSending, setShowSending] = React.useState<boolean>(false);
    const [showIncludeCovet, setShowIncludeCovet] = React.useState<boolean>((category === "Vaccinations") &&
        examData && examData.coVet && examData.coVet.fields &&
        (examData.coVet.fields.length > 0));
    const [showIncludeVaccinations, setShowIncludeVaccinations] = React.useState<boolean>((category === "CoVet") &&
        examData && examData.vaccinations && examData.vaccinations.fields &&
        (examData.vaccinations.fields.length > 1) && (examData.vaccinations.fields[1].results.length > 0));
    const [showCW, setShowCW] = React.useState<boolean>(examData.cwemail && (examData.cwemail !== ""));
    const [fields, setFields] = React.useState<any>(null);
    const [errorMsg, setErrorMsg] = React.useState<string>("");

    interface examInterface {
        to: string;
        covet?: boolean;
        vaccinations?: boolean;
    }
    const [examValues, setExamValues] = React.useState<examInterface>({
        to: (examData && examData.owneremail) ? examData.owneremail : "",
        covet: false,
        vaccinations: false,
    });

    const pdfExportComponent = React.useRef<PDFExport>(null);

    React.useEffect(() => {
        if (examData) {

            var categories = [
                { name: "Info", fields: [] },
                { name: "Schedule", fields: examData.schedule.fields },
                { name: "Services", fields: examData.services.fields },
                { name: "Eligibility", fields: examData.eligibility.fields },
                { name: "Waivers", fields: examData.waivers.fields },
                { name: "Questionnaire", fields: examData.questionnaire.fields },
                { name: "ExamRecord", fields: examData.examRecord.fields },
                { name: "Vaccinations", fields: examData.vaccinations.fields },
                { name: "Comments", fields: examData.comments.fields },
                { name: "Attachments", fields: examData.attachments.fields },
                { name: "CoVet", fields: examData.coVet.fields },
           ];

            const match: any = categories.find(({ name }) => name === category);
            setFields(match.fields);
        }
    }, [examData, category]);

    const editReturned = (refresh: boolean) => {
        setIsEdit(false);
        if (refresh) {
            setFields(null);
        }
    }

    const caseWorkerClicked = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        setExamValues({ to: (examData && examData.cwemail) ? examData.cwemail : "" });;
    }

    const submitForm = (event: FormSubmitClickEvent) => {

        const { isValid } = event;

        setErrorMsg("");

        if (isValid) {
            setShowSending(true);

            const postMail = EmailForm.current.values;
            postMail.examid = examData ? examData.uid : 0;

            if (category === "Vaccinations") {
                postMail.vaccinations = true;
                postMail.covet = EmailForm.current.values.covet;
            }
            else {
                postMail.covet = true;
                postMail.vaccinations = EmailForm.current.values.vaccinations;
            }

            sendMail(postMail)
                .unwrap()
                .then((payload) => { setShowSending(false); setShowEmail(false) })
                .catch((error) => {
                    console.log(error)
                    setErrorMsg("Unable to send report.")
                    setShowSending(false);
                });
        }
    }

    const formatFindingField: any = (field: any) => {

        const dateFields: number[] = [149, 313, 317, 321, 336, 343, 347];
        const timeFields: number[] = [333, 334];

        if (field && field.result && (dateFields.indexOf(field.result.findingID) !== -1)) {
            return field.result.a ? (new Date(field.result.a)).toLocaleDateString() : "";
        }
        else if (field && field.result && (timeFields.indexOf(field.result.findingID) !== -1)) {
            return field.result.a ? (new Date(field.result.a)).toLocaleString() : "";
        }

        return field.result.a;
    }

    const printOrPDF = (print: boolean) => {
        if ((category === "ExamRecord") && !print) {
            if (pdfExportComponent.current) {
                pdfExportComponent.current.save();
            }
        }
        else {
            const printWindow = window.open('', '_blank');
            if (printWindow) {
                printWindow.document.write('<html><head><title>' + category + '</title ></head > <body>');
                if (category === "Vaccinations") {
                    //printWindow.document.write("<div style=\"text-align:center\"><img src=\"CVO-Logo-Header-200.png\" alt=\"CVO\"></div>");

                    let vaccineDate = "2024-01-13"; // First release for Toronto did not have a vaccination date as part of the page.
                    // Subsequent releases include a required date field (A336). 
                    // This default should always be overwritten.

                    examData.vaccinations.fields.forEach((field: any) => {
                        if ((field.t === "finding") && (field.result.findingID === 336)) {
                            vaccineDate = field.result.a.slice(0, 10);
                        }
                    })

                    let dob = "";
                    const dobSplit = examData.petdob.split(" ");
                    if (dobSplit.length >= 1) {
                        dob = dobSplit[0];
                    }

                    printWindow.document.write(
                        "<p><table style=\"border-spacing: 32px 0px\">" +
                        "<tr><td rowspan=\"4\"><img src=\"CVO-Logo-Header-200.png\" alt=\"CVO\"/></td>" +
                        "<td>" + examData.regionName + " Community Veterinary Outreach Mobile</td></tr>" +
                        "<tr><td>" + examData.vetaddress + "</td></tr>" +
                        "<tr><td>Phone: " + examData.vetphone + "</td></tr>" +
                        "<tr><td>email: " + examData.regionEmail + "</td></tr>" +
                        "</table></p>" +

                        "<p><table style=\"border-spacing: 20px 0px\">" +
                        "<tr><td style=\"font-weight:bold\">Owner</td><td>Name:</td><td>" + examData.ownerfirst + " " + examData.ownerlast + "</td></tr>" +
                        "<tr><td /><td>Address:</td><td>" + examData.owneraddress1 + " " + examData.ownercity + " " + examData.ownerprovince + "</td></tr>" +
                        "<tr><td>&nbsp</td></tr>" +
                        "<tr><td style=\"font-weight:bold\">Pet</td><td>Name:</td><td>" + examData.petname + "</td></tr>" +
                        "<tr><td /><td /><td>" + examData.petspecies + ": " + examData.petgender + " / " + examData.petbreed +
                        " / " + examData.petbreedother + " / " + examData.petcolor + "</td></tr>" +
                        "<tr><td /><td>Weight:</td><td>" + examData.petweight + " kg</td></tr>" +
                        "<tr><td /><td>DOB:</td><td>" + dob + "</td></tr>" +
                        "<tr><td /><td>Microchip:</td><td>" + examData.petmicrochipref + "</td></tr>" +
                        "</table></p>" +

                        "<div style=\"margin-left:48px\">" +

                        "<p><span style=\"font-weight:bold\">Vaccination Date: </span><span>" + vaccineDate + "</span></p>");

                    examData.vaccinations.fields.forEach((field: any) => {
                        if (field.t === "grid") {
                            printWindow.document.write("<p><br/>");
                            field.results.forEach((result: any) => {
                                if ((result.findingID === 311) || (result.findingID === 315) || (result.findingID === 319) ||
                                    (result.findingID === 341) || (result.findingID === 345)) {
                                    printWindow.document.write("</p><p/><p><div style=\"font-weight:bold\">" + result.a + "</div>");
                                } else if ((result.findingID === 313) || (result.findingID === 317) || (result.findingID === 321) ||
                                    (result.findingID === 343) || (result.findingID === 347)) {
                                    printWindow.document.write("<div>" + result.q + ": " + result.a.slice(0, 10) + "</div>");
                                } else {
                                    printWindow.document.write("<div>" + result.q + ": " + result.a + "</div>");
                                }
                            })
                            printWindow.document.write("</p>");
                        }
                    })

                    printWindow.document.write("</div>" + "<p><span style=\"font-weight:bold\">Veterinarian: </span><span>" + examData.vetname + " (" + examData.vetcredentials + ")</span></p>");

                    if (examData.vetsignaturetype !== "") {
                        printWindow.document.write("<p><img src='s/" + examData.vetid + "." + examData.vetsignaturetype + "'></p>");
                    }

                    printWindow.document.write("<p style=\"font-style:italic\"><br/>" +
                        "Please call 888-755-3750 following clinic events if you suspect a vaccine related " +
                        "issue with your pet.This number will be monitored for 24 hours following clinic events.The number allows connection " +
                        "to specific regions(listen to the options and press the number of your specific region) and is not a live answered number. " +
                        "Please leave a specific message including you and your pet’s name, cell phone number, and your email, and a " +
                        "volunteer from your region will respond to your inquiry within 12 - 24 hours.</p>");

                }
                printWindow.document.write('</body></html>');
                printWindow.document.close();

                printWindow.onload = function () {
                    if (print) {
                        printWindow.print();
                    } else {
                        savePDF(printWindow.document.body, {
                            paperSize: "Letter",
                            margin: 40,
                            fileName: examData.petname + "-" + examData.ownerfirst + examData.ownerlast + "-vaccination",
                        });
                    }
                    printWindow.close();
                }
            }
        }
    };

    return (
        <React.Fragment>
            {!viewOnly && (
                <div style={{ position: "fixed", top: "124px", right: "34px", zIndex: "99" }}>
                    <ButtonGroup>
                        {canEdit && <Button
                            icon="edit"
                            themeColor={"primary"}
                            onClick={() => setIsEdit(true)}>
                            Edit
                        </Button>}
                        {canPrint && <Button
                            icon="print"
                            style={{ borderLeftColor: "white", borderLeftWidth: "1px" }}
                            disabled={false}
                            onClick={() => printOrPDF(true)}
                            themeColor={"primary"}>
                            Print
                        </Button>}
                        {canPDF && <Button
                            imageUrl="file-pdf.svg"
                            style={{ borderLeftColor: "white", borderLeftWidth: "1px" }}
                            disabled={false}
                            onClick={() => printOrPDF(false)}
                            themeColor={"primary"}>
                            PDF
                        </Button>}
                        {canEmail && <Button
                            icon="chevron-double-right"
                            style={{ borderLeftColor: "white", borderLeftWidth: "1px" }}
                            disabled={false}
                            onClick={() => setShowEmail(true)}
                            themeColor={"primary"}>
                            Email
                        </Button>}
                   </ButtonGroup>
                </div>)
            }
            {(canPDF && (category==="ExamRecord")) &&
                <div style={{ position: "absolute", left: "-10000px", top: 0, maxWidth: "2000px" }}>
                    <PDFExport paperSize="A4" margin="1cm" scale={.5} ref={pdfExportComponent}
                        fileName={examData.petname + "-" + examData.ownerfirst + examData.ownerlast + "-exam"}>
                        <ExamPDF examData={examData} info={info} qWidth={qWidth} cellWithHtml={cellWithHtml} formatFindingField={formatFindingField} />
                    </PDFExport>
                </div>
            }
            {(showEmail) &&
                <Dialog
                    title={(category === "Vaccinations") ? "Email Vaccination Report" : "Email CoVet Summary"}
                    className="sds-send-dialog"
                    onClose={(e) => setShowEmail(false)}>
                    {(showSending) ?
                        (<div style={{textAlign:"center", paddingTop:"16px"} }>
                            <Loader size='large' type="converging-spinner" />
                            <span><br/><br/>Sending...</span>
                        </div>) :
                        (<Form
                            ref={EmailForm}
                            initialValues={examValues}
                            key={JSON.stringify(examValues)}
                            onSubmitClick={submitForm}
                            render={(formRenderProps: FormRenderProps) => (
                                <div>
                                    <FormElement style={{ paddingTop: "16px", paddingBottom: "16px", width: "300px" }}>
                                        <div className={"sds-questionnaire"}>
                                            <fieldset
                                                style={{}}
                                                className={"k-form-fieldset"}
                                            >
                                               <Field
                                                    label={"To"}
                                                    name={"to"}
                                                    component={FormInput}
                                                    validator={emailRequiredValidator}
                                                />
                                                <div style={{ marginLeft: "16px", marginTop: "16px", visibility: showCW ? "visible" : "hidden" }}>
                                                    <Button
                                                        style={{float: "inline-end", backgroundColor: "rgba(173, 216, 230, 0.4)"}}
                                                        onClick={caseWorkerClicked}
                                                    >
                                                        Use Case Worker Email
                                                    </Button>
                                                </div>
                                            </fieldset>
                                            {showIncludeCovet && (
                                                <fieldset
                                                    style={{}}
                                                    className={"k-form-fieldset"}
                                                >
                                                    <Field
                                                        label={"Include CoVet Summary"}
                                                        name={"covet"}
                                                        component={FormCheckbox}
                                                    />
                                                </fieldset>
                                            )}
                                            {showIncludeVaccinations && (
                                                <fieldset
                                                    style={{}}
                                                    className={"k-form-fieldset"}
                                                >
                                                    <Field
                                                        label={"Include Vaccinations"}
                                                        name={"vaccinations"}
                                                        component={FormCheckbox}
                                                    />
                                                </fieldset>
                                            )}
                                        </div>
                                    </FormElement>
                                   <div style={{ color: "red", paddingBottom: "8px", fontStyle: "italic" }}>{errorMsg}</div>
                                    <DialogActionsBar>
                                        <button
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                            onClick={formRenderProps.onSubmit}
                                        >
                                            Send
                                        </button>
                                        <button
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                            onClick={(e) => setShowEmail(false)}
                                        >
                                            Cancel
                                        </button>
                                    </DialogActionsBar>
                                </div>
                            )}
                        />)
                    }
                </Dialog>
            }
            {isEdit ?
                (<Dialog contentStyle={{ width: "1170px" }}>
                    <ExamEdit
                        examID={examID}
                        examData={examData}
                        category={category}
                        fields={fields}
                        onReturn={(refresh: boolean) => editReturned(refresh)}
                    />
                </Dialog>)
                :
                ((fields === null) ? <Loader size="large" type="converging-spinner" /> :
                ((category === "Info") ?
                    <ExamViewClientPet
                            examID={examID}
                            petID={examData.petid }
                            examData={examData}
                            viewOnly={viewOnly }
                        category="Info"
                    />
                    : 
                ((category === "Attachments") ?
                    <ExamViewAttachments
                        examID={examID}
                        fields={fields}
                        category="Attachments"
                    />
                    :
                    <Form
                    render={(formRenderProps: FormRenderProps) => (
                        <FormElement style={{}}>
                                <fieldset className={"k-form-fieldset"} >
                                {fields.map((field: any) => {
                                    return ((field.t === "info") ?
                                        (<div className="k-form-field-wrap" style={{ marginTop: info[field.i - 1].gap}}>
                                            <Editor style={{ backgroundColor: "aliceblue"}}
                                                contentStyle={{ height: field.i ? info[field.i - 1].h : "", overflowX: "hidden" }}
                                                defaultContent={field.i ? info[field.i - 1].t : ""}
                                                defaultEditMode={"div"}
                                                tools={[]}
                                            />
                                        </div>)
                                        :
                                        ((field.t === "finding") ?
                                            (
                                                (field.result.findingID === 394) ?
                                                    (<Editor style={{ backgroundColor: "aliceblue" }}
                                                        contentStyle={{ height: "100%" }}
                                                        defaultContent={field.result.n ? field.result.n : ""}
                                                        defaultEditMode={"div"}
                                                        tools={[]}
                                                    />
)
                                                :
                                                    (<FieldWrapper>
                                                        <div className="k-form-field-wrap" style={{ backgroundColor: "lightblue" }}>
                                                            <Label className="k-form-label">{field.result.q}</Label>
                                                            <Field
                                                                name={"A" + field.result.findingID}
                                                                defaultValue={formatFindingField(field) + " " + field.result.n}
                                                                style={{
                                                                    fontWeight: "bold",
                                                                    color: field.result.alert ? (field.result.a.startsWith(field.result.alert) ? "red" : "green") : "",
                                                                    height: field.result.findingID === 323 ? "200px" :
                                                                        (field.result.findingID === 310 ? "350px" : "")
                                                                }}
                                                                disabled={!(field.result.n.indexOf('\n') !== -1)}
                                                                readOnly={true }
                                                                component={((field.result.a.indexOf('\n') !== -1) || (field.result.n.indexOf('\n') !== -1)) ? TextArea : TextBox}
                                                            />
                                                        </div>
                                                    </FieldWrapper>)
                                                ) :
                                            ((field.t === "grid") ?
                                            (<Grid
                                                data={field.results}
                                                style={{ fontWeight: "bold" }}
                                                className={"sds-no-header sds-no-yscroll"}
                                           >
                                                <GridColumn field="q" width={qWidth} />
                                                <GridColumn field="a" cell={cellWithHtml} />
                                                <GridColumn field="n" cell={cellWithHtml} />
                                            </Grid>) :
                                            (<Grid
                                                    data={field.results}
                                                    style={{ fontWeight: "bold" }}
                                                >
                                                    <GridColumn field="q" title = " " width={qWidth} />
                                                    <GridColumn field="a1" title = "Discussed" cell={cellWithHtml} />
                                                    <GridColumn field="a2" title = "Handout" cell={cellWithHtml} />
                                            </Grid>)
                                        )))
                                })}
                            </fieldset>
                        </FormElement>
                    )}
                />)))
            }
       </React.Fragment>
    );
};
export default ExamTab;
